/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import saveOrDiscardOptions from '../utils/saveOrDiscardOptions';
export var discardOptions = orchestratorAction('discardOptions', function discardOptions() {
    saveOrDiscardOptions(false);
});
//# sourceMappingURL=discardOptions.js.map